import React, { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom"; // Import `useLocation` from react-router-dom
import logo from "../assests/Images/companylogo.png";
import { useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/navbar.css';

function Navbar() {
  const [isScrolled] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false); // State to handle sidebar visibility
  const location = useLocation(); // Get the current location (route)
  const navigate = useNavigate(); // Initialize the navigate function

  const handleNavigation = (e, targetId) => {
    if (location.pathname !== "/") {
      // If not on the homepage, navigate to the homepage
      e.preventDefault(); // Prevent the default behavior (like refreshing the page)
      navigate("/#" + targetId); // Navigate to the home page
      console.log("Navigating to: /#" + targetId); // Log the navigation for debugging
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        window.scrollTo({
          top: targetElement.offsetTop - 300, // Adjust offset here
          behavior: "smooth", // Optional: for smooth scrolling
        });
      }
      // window.scrollTo(0, 0); // Scroll to the top of the page
      
    } else {
      // If already on the homepage, scroll to the section directly
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        window.scrollTo({
          top: targetElement.offsetTop - 120, // Adjust offset here
          behavior: "smooth", // Optional: for smooth scrolling
        });
      }
    }
  };

  useEffect(() => {
    // const handleScroll = () => {
    //   if (window.scrollY > 100) {
    //     setIsScrolled(true);
    //   } else {
    //     setIsScrolled(false);
    //   }
    // };

    // window.addEventListener("scroll", handleScroll);
    // return () => {
    //   window.removeEventListener("scroll", handleScroll);
    // };
  }, []);

  const headerClass = isScrolled ? "header-scrolled" : "header";
  const menuOptionsClass = isScrolled
    ? "menu-options-scrolled list-unstyled d-flex align-items-center"
    : "menu-options list-unstyled";

  return (
    <div >
      <header className={headerClass}>
        <div  id="navbar-body-container" className="navbar-container">
          <Link to="/">
            <div className="logo-container">
              <img src={logo} alt="Logo" />
            </div>
          </Link>
          <div className="menu-opitions-container">
            <ul className={menuOptionsClass}>
              <li>
                <a
                  className="menu-option"
                  id="menu-option-link"
                  href="#aboutus"
                  onClick={(e)=>{ handleNavigation(e, "aboutus");}} 
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  className="menu-option"
                  id="menu-option-link"

                  href="#services"
                  onClick={(e) => handleNavigation(e, "services")}
                >
                  Services
                </a>
              </li>
              <li>
                <a
                  className="menu-option"
                  id="menu-option-link"

                  href="https://marinersmentor.onlinetestpanel.com/#home-slider"
                  target="blank"
                >
                  Exams
                </a>
              </li>
              <li>
                <a  id="menu-option-link" className="menu-option"  onClick={(e)=>{ handleNavigation(e, "testimonial");}}  href="#testimonial" >

                  Testimonial
                </a>
              </li>
              <li>
                <a id="menu-option-link" className="menu-option" href="institutes">
                  Institutes
                </a>
              </li>
              <li>
                <a id="menu-option-link" className="menu-option" href="courses">
                  Courses
                </a>
              </li>
            </ul>
          </div>
          <div className="enquiry-button-container  desktop-enquiry">
            <a href="#getintouchform" 
              onClick={(e) => {
                setShowSidebar(false);
                handleNavigation(e, "getintouchform");
              }}
            id="enquiryButton">
              Enquire Now
            </a>
          </div>

          {/* Mobile Sidebar Button */}
          <div className="mobile-sidebar-btn">
            <button onClick={() => setShowSidebar(true)}>
            ≡
            </button>
          </div>

          {/* Sidebar */}
          <div
            className={`sidebar ${showSidebar ? "show-sidebar" : ""}`}
            style={{
              position: "fixed",
              top: 0,
              left: showSidebar ? "0" : "-250px", // Sidebar visible when true
              width: "250px",
              height: "100%",
              backgroundColor: "#f8f9fa",
              transition: "left 0.3s ease-in-out", // Smooth transition for sliding effect
              zIndex: "999",
              padding: "20px",
              boxShadow: "2px 0 5px rgba(0,0,0,0.2)",
            }}
          >
            <button
              className="close-btn"
              onClick={() => setShowSidebar(false)} // Close sidebar
              style={{
                position: "absolute",
                top: "3px",
                right: "13px",
                background: "transparent",
                border: "none",
                fontSize: "35px",
                color: "#000",
              }}
            >
              &times; {/* Close icon */}
            </button>
            <ul className="sidebar-links" style={{ listStyle: "none", padding: 0 }}>
              <li style={{ marginBottom: "25px" }}>
                <a
                  className="menu-option1"
                  href="#aboutus"
                  onClick={(e) => {
                    setShowSidebar(false); // Close sidebar after clicking
                    handleNavigation(e, "aboutus");
                  }}
                >
                  About Us
                </a>
              </li>
              <li style={{ marginBottom: "25px" }}>
                <a
                  className="menu-option1"
                  href="#services"
                  onClick={(e) => {
                    setShowSidebar(false);
                    handleNavigation(e, "services");
                  }}
                >
                  Services
                </a>
              </li>
              <li style={{ marginBottom: "25px" }}>
                <a
                  className="menu-option1"
                  href="https://marinersmentor.onlinetestpanel.com/#home-slider"
                  onClick={() => setShowSidebar(false)}
                  target="blank"
                >
                  Exams
                </a>
              </li>
              <li style={{ marginBottom: "25px" }}>
                <a
                  className="menu-option1"
                  href="#testimonial"
                  onClick={(e) => {
                    setShowSidebar(false);
                    handleNavigation(e, "testimonial");
                  }}
                >
                  Testimonial
                </a>
              </li>
              <li style={{ marginBottom: "25px" }}>
                <a
                  className="menu-option1"
                  href="courses"
                  onClick={() => setShowSidebar(false)}
                >
                  Courses
                </a>
              </li>
              <li style={{ marginBottom: "25px" }}>
                <a
                  className="menu-option1"
                  href="/institutes"
                  onClick={() => setShowSidebar(false)}
                >
                  Institutes
                </a>
              </li>
            </ul>
            <div className="mt-3">
              <a href="#getintouchform"  onClick={(e) => {
                setShowSidebar(false)
                handleNavigation(e, "getintouchform");
                }  
                } className="btn btn-primary primary-btn" id="enquiryButton">
                Enquire Now
              </a>
            </div>

          </div>
        </div>
      </header>
    </div>
  );
}

export default Navbar;
